import React from 'react';
import {Page, Text, View, Document, StyleSheet} from '@react-pdf/renderer';
import {DateFormatter} from "../../../../services/date";

// Create styles
const BORDER_COLOR = '#bfbfbf';
const BORDER_STYLE = 'solid';
const NUMBER_OF_COL = 4;
const PADDING_HORIZONTAL = 32;

const styles = StyleSheet.create({
    page: {
        paddingTop: 32,
        paddingBottom: 40,
        paddingHorizontal: PADDING_HORIZONTAL,
    },
    header: {
        marginBottom: 16
    },
    title: {
        textAlign: 'center',
        marginBottom: 16,
        fontSize: 24,
    },
    bookingDetails: {
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between"
    },
    property: {
        display: "flex",
        flexDirection: "column",
    },
    propertyLabel: {
        color: 'grey',
        fontSize: 12,
    },
    propertyValue: {
        fontSize: 12,
    },
    pageNumber: {
        position: 'absolute',
        fontSize: 10,
        bottom: 16,
        left: 0,
        right: PADDING_HORIZONTAL,
        textAlign: 'right',
        color: 'grey',
    },
    credits: {
        position: 'absolute',
        fontSize: 10,
        bottom: 16,
        left: PADDING_HORIZONTAL,
        right: 0,
        textAlign: 'left',
        color: 'grey',
    },
    table: {
        display: "table",
        width: "auto",
        borderStyle: BORDER_STYLE,
        borderColor: BORDER_COLOR,
        borderWidth: 0,
        borderLeftWidth: 1
    },
    tableRow: {
        margin: "auto",
        flexDirection: "row"
    },
    tableColHeader: {
        borderStyle: BORDER_STYLE,
        borderColor: BORDER_COLOR,
        borderBottomColor: '#000',
        borderWidth: 1,
        borderLeftWidth: 0,
    },
    tableCol: {
        borderStyle: BORDER_STYLE,
        borderColor: BORDER_COLOR,
        borderWidth: 1,
        borderLeftWidth: 0,
        borderTopWidth: 0
    },
    tableCellHeader: {
        margin: 5,
        fontSize: 12
    },
    tableCell: {
        margin: 5,
        fontSize: 10
    },
    col1: {
        width: '4%'
    },
    colAuto: {
        width: `${(100 - 4) / NUMBER_OF_COL}%`
    }
});

// Create Document Component
const PdfGuestList = props => {
    const {booking, findAccommodationUnit} = props;

    const guests = [...booking.guests].sort((a, b) => a.surname.localeCompare(b.surname) || a.name.localeCompare(b.name));
    const arrivalString = DateFormatter.longString(booking.getArrival());
    const departureString = DateFormatter.longString(booking.getDeparture());

    return (
        <Document>
            <Page size="A4" orientation="landscape" style={styles.page}>
                <View style={styles.header} fixed>
                    <Text style={styles.title}>
                        Dettaglio ospiti
                    </Text>
                    <View style={styles.bookingDetails}>
                        <View style={styles.property}>
                            <Text style={styles.propertyLabel}>
                                {booking.bookingItems.length > 1 ? 'Strutture prenotate': 'Struttura prenotata'}
                            </Text>
                            {
                                booking.bookingItems.map(i => {
                                    const accommodationUnit = findAccommodationUnit(i.bookableType, i.bookableId);
                                    const {accommodation, name} = accommodationUnit;
                                    return (
                                        <Text key={`${i.bookableType}-${i.bookableId}`} style={styles.propertyValue}>
                                            {accommodation.name} - {name}
                                        </Text>
                                    )
                                })
                            }
                        </View>
                        <View style={styles.property}>
                            <Text style={styles.propertyLabel}>
                                Periodo
                            </Text>
                            <Text style={styles.propertyValue}>
                                {`${arrivalString} - ${departureString}`}
                            </Text>
                        </View>
                    </View>
                </View>

                <View style={styles.table}>
                    <View style={styles.tableRow} fixed>
                        <View style={[styles.tableColHeader, styles.col1]}>
                            <Text style={styles.tableCellHeader}>N°</Text>
                        </View>
                        <View style={[styles.tableColHeader, styles.colAuto]}>
                            <Text style={styles.tableCellHeader}>Cognome</Text>
                        </View>
                        <View style={[styles.tableColHeader, styles.colAuto]}>
                            <Text style={styles.tableCellHeader}>Nome</Text>
                        </View>
                        <View style={[styles.tableColHeader, styles.colAuto]}>
                            <Text style={styles.tableCellHeader}>Nazionalità</Text>
                        </View>
                        <View style={[styles.tableColHeader, styles.colAuto]}>
                            <Text style={styles.tableCellHeader}>Data di nascita - età</Text>
                        </View>
                    </View>
                    {
                        guests.map((g, i) => (
                            <View key={g.id} style={styles.tableRow} wrap={false}>
                                <View style={[styles.tableCol, styles.col1]}>
                                    <Text style={styles.tableCell}>{i + 1}</Text>
                                </View>
                                <View style={[styles.tableCol, styles.colAuto]}>
                                    <Text style={styles.tableCell}>{g.surname}</Text>
                                </View>
                                <View style={[styles.tableCol, styles.colAuto]}>
                                    <Text style={styles.tableCell}>{g.name}</Text>
                                </View>
                                <View style={[styles.tableCol, styles.colAuto]}>
                                    <Text style={styles.tableCell}>{g.nationality.label}</Text>
                                </View>
                                <View style={[styles.tableCol, styles.colAuto]}>
                                    <Text style={styles.tableCell}>{
                                        `${DateFormatter.dmyString(g.dateOfBirth)} - ${g.getAge()} anni`
                                    }</Text>
                                </View>
                            </View>
                        ))
                    }
                </View>

                <Text style={styles.credits} fixed>
                    Report generato tramite LivignoItaly.it
                </Text>

                <Text style={styles.pageNumber} render={({pageNumber, totalPages}) => (
                    `Pagina ${pageNumber} / ${totalPages}`
                )} fixed/>
            </Page>
        </Document>
    )
};

export default PdfGuestList;